// Main application component with routing
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';

// Pages
import Home from './pages/Home';
import FileSets from './pages/FileSets';
import FileDetails from './pages/FileDetails';
import ScrapeJobs from './pages/ScrapeJobs';
import NewScrapeJob from './pages/NewScrapeJob';
import ScrapeJobDetails from './pages/ScrapeJobDetails';
import AnalysisJobs from './pages/AnalysisJobs';
import NewAnalysisJob from './pages/NewAnalysisJob';
import AnalysisJobDetails from './pages/AnalysisJobDetails';
import Zen from './pages/Zen';
import AdminSettings from './pages/AdminSettings';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Zen Mode as Root */}
          <Route path="/" element={<Zen />} />
          
          {/* Advanced Mode Routes */}
          <Route path="/advanced" element={<Home />} />
          
          {/* File Sets Routes */}
          <Route path="/advanced/file-sets" element={<FileSets />} />
          <Route path="/advanced/file-sets/:fileSetId" element={<FileDetails />} />
          
          {/* Scrape Jobs Routes */}
          <Route path="/advanced/scrape-jobs" element={<ScrapeJobs />} />
          <Route path="/advanced/scrape-jobs/new" element={<NewScrapeJob />} />
          <Route path="/advanced/scrape-jobs/:jobId" element={<ScrapeJobDetails />} />
          
          {/* Analysis Jobs Routes */}
          <Route path="/advanced/analysis-jobs" element={<AnalysisJobs />} />
          <Route path="/advanced/analysis-jobs/new" element={<NewAnalysisJob />} />
          <Route path="/advanced/analysis-jobs/:jobId" element={<AnalysisJobDetails />} />
          
          {/* Admin Routes */}
          <Route path="/advanced/admin" element={<AdminSettings />} />
          
          {/* Redirect Legacy Zen Mode Route */}
          <Route path="/zen" element={<Navigate to="/" replace />} />
          
          {/* Redirect old routes to advanced */}
          <Route path="/file-sets/*" element={<Navigate to="/advanced/file-sets" replace />} />
          <Route path="/scrape-jobs/*" element={<Navigate to="/advanced/scrape-jobs" replace />} />
          <Route path="/analysis-jobs/*" element={<Navigate to="/advanced/analysis-jobs" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;